/**********************************************************************
INICIO 
Slide Cart, esconde barra de progresso para ofertas estilo TIER
 **********************************************************************/
// 
function hideProgressBar() {
    let progressBar = document.querySelector('[data-testid="TieredRewardsProgressBar"]');
    if (progressBar) {
        progressBar.style.display = "none";
        console.log("Progress bar hidden");
    } else {
        setTimeout(hideProgressBar, 500); // Retry after 500ms if not found
    }
}
document.addEventListener("DOMContentLoaded", hideProgressBar);
/**********************************************************************
//
//
/**********************************************************************
INICIO 
Product Page, Calculadora frete
 **********************************************************************/
// 

document.addEventListener('DOMContentLoaded', () => {
  const styleElement = (selector, styles) => {
    const el = document.querySelector(selector);
    if (el) {
      Object.assign(el.style, styles);
    }
  };

  styleElement('.form_input', {
    border: '1px solid #707173',
    borderRadius: '3px',
  });

  styleElement('.search_zipcode.btnForm', {
    border: '1px solid #707173',
    borderRadius: '3px',
    backgroundColor: '#F2F2F2',
    color: '#4D4D4D',
  });

  const btnCalcular = document.querySelector('.search_zipcode.btnForm');
  if (btnCalcular) {
    btnCalcular.textContent = "Calcular";
    btnCalcular.addEventListener('click', () => {
      styleElement('.ship-price', { color: '#4D4D4D'});
      styleElement('.localization', { backgroundColor: '#ffff'});
      styleElement('.localization span', { color: '#4D4D4D'});
      styleElement('.localization svg path', { fill: '#4D4D4D'});
    });
  }

  // Change "Calcule o Frete" to "Consulte o prazo de entrega":
  const calculeFreteSpan = document.querySelector('form#formKokfyShipping span'); // Select the span
  if (calculeFreteSpan) {
    calculeFreteSpan.textContent = "Consulte o prazo de entrega"; // Change the text
  }
});

/**********************************************************************/
//
//
/**********************************************************************
INICIO 
Pagina Personalize, Calculadora Botao Whatsapp "b2b"
 **********************************************************************/
// 
if (window.location.href.includes("b2b")) {
  document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('a'); // Select all anchor tags
    buttons.forEach(function(button) {
      if (button.textContent.toLowerCase().includes('whatsapp')) { // Check if button text contains "whatsapp" (case-insensitive)
        // Add flexbox styles to center the icon and text
        button.style.display = 'inline-flex'; // Use flexbox for layout
        button.style.alignItems = 'center'; // Align items vertically
        button.style.gap = '8px'; // Add spacing between icon and text
        
        var img = document.createElement('img'); // Create an img element
        img.src = 'https://cdn.shopify.com/s/files/1/2582/6660/files/whatsapp-64.png?v=1736963039'; // Path to the WhatsApp logo
        img.alt = 'WhatsApp Logo';
        img.style.width = '20px';
        img.style.height = '20px';
        
        button.prepend(img); // Add the logo before the button text
  
        // Add click event listener to track WhatsApp button clicks in GA4
        if (button.href.includes('https://wa.me/5541988389098')) { // Ensure this is the WhatsApp button
          button.addEventListener('click', function() {
            gtag('event', 'click', {
              event_category: 'button',
              event_label: 'Cotacao Whatsapp LP B2B', // Updated button name
              value: 1 // Optional: Add a value if needed
            });
          });
        }
      }
    });
  });
}
/**********************************************************************/
//
//
/**********************************************************************
INICIO 
Header,Barra de anúncio sticky
 **********************************************************************/
// 
document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.getElementById('shopify-section-announcement-bar');
  if (announcementBar) {
    if (!window.location.href.includes('b2b')) { // Check if URL *does not* contain "B2B"
      const style = document.createElement('style');
      style.textContent = `
        #shopify-section-announcement-bar {
          position: sticky;
          top: 0px;
          z-index: 500;
        }
      `;
      document.head.appendChild(style);
    } else {
        announcementBar.style.display = 'none'; // Hide the element
    }
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.getElementById('shopify-section-announcement-bar');
  const header = document.getElementById('shopify-section-header');

  if (announcementBar && header) {
    if (!window.location.href.includes('B2B')) {
      const style = document.createElement('style');
      style.textContent = `
        #shopify-section-announcement-bar {
          position: sticky;
          top: 0px;
          z-index: 500;
        }
      `;
      document.head.appendChild(style);


      // Function to adjust header top
      function adjustHeaderTop() {
        if (announcementBar.style.display !== 'none') { // only if announcement bar is visible
          const announcementBarHeight = announcementBar.offsetHeight;
          header.style.top = `${announcementBarHeight}px`;
        } else {
          header.style.top = ''; // Reset top if announcement bar is hidden
        }
      }

      // Initial adjustment
      adjustHeaderTop();

      // Adjust on resize (important!)
      window.addEventListener('resize', adjustHeaderTop);

      // Adjust if content of announcement bar changes (if applicable)
      // This is a more advanced technique and depends on how your announcement bar content changes.
      // If you're using JavaScript to update the content, you can call adjustHeaderTop()
      // after you've made the content change.  If the content changes dynamically without
      // your direct JavaScript control, you might need a MutationObserver (see below).

      // Example using MutationObserver (if content changes dynamically):
      const observer = new MutationObserver(adjustHeaderTop);
      observer.observe(announcementBar, { childList: true, subtree: true, attributes: true, characterData: true }); // Observe changes in child list and subtree

    } else {
      announcementBar.style.display = 'none';
      // header.style.display = 'none'; // Uncomment if you want to also hide the header in B2B
    }
  }
});


//Esconde elementos de adicionar ao carrinho, quantidade e calculo de frete para as páginas de produtos para B2B
document.addEventListener('DOMContentLoaded', function() {
    const productNameElement = document.querySelector('.title-row .title');
    
    const productName = productNameElement ? encodeURIComponent(productNameElement.textContent.trim()) : '';

    const whatsappUrl = `https://api.whatsapp.com/send?phone=5541988389098&text=Ol%C3%A1%2C%20tenho%20interesse%20no%20%27${productName}%27`;

    if (productNameElement && productNameElement.textContent.toLowerCase().includes('personalizado')) {

        // --- 1. Esconder os elementos de Quantidade ---
        const quantityLabel = document.querySelector('.quantity-submit-row.input-row .label[for="quantity"]');
        const quantityWrapper = document.querySelector('.quantity-submit-row.input-row .quantity-wrapper');

        if (quantityLabel) {
            quantityLabel.style.display = 'none';
        }
        if (quantityWrapper) {
            quantityWrapper.style.display = 'none';
        }

        // --- 2. Esconder o bloco de Cálculo de Frete ---
        const shippingCalculatorBlock = document.querySelector('.calculoFrete');
        if (shippingCalculatorBlock) {
            shippingCalculatorBlock.style.display = 'none';
        }

        // --- 3. Esconder o bloco "Leve junto e economize" ---
        const bundleBlock = document.querySelector('.lightly-spaced-row.lightly-spaced-row-above.not-in-quickbuy');
        if (bundleBlock) {
            bundleBlock.style.display = 'none';
        }

        // --- 4. Esconder o acordeão "Envios e prazos" ---
        const enviosSummary = Array.from(document.querySelectorAll('.product-detail-accordion .cc-accordion-item__title')).find(summary =>
            summary.textContent.includes('Envios e prazos')
        );

        if (enviosSummary) {
            const enviosAccordionItem = enviosSummary.closest('.cc-accordion-item');
            if (enviosAccordionItem) {
                enviosAccordionItem.style.display = 'none';
            }
        }

        // --- 5. Esconder o bloco de Recomendações de Produtos (AGORA DINÂMICO) ---
        // Usamos as classes para selecionar a seção de recomendações, que é mais robusto que o ID dinâmico.
        const productRecommendations = document.querySelector('.shopify-section.section-product-recommendations');
        if (productRecommendations) {
            productRecommendations.style.display = 'none';
        }

        // --- 6. Substituir o botão "Adicionar ao carrinho" por um do WhatsApp ---
        const originalButtonContainer = document.querySelector('.quantity-submit-row__submit.input-row');
        const originalAddToCartButton = originalButtonContainer ? originalButtonContainer.querySelector('button[type="submit"][data-add-to-cart-text]') : null;

        if (originalAddToCartButton && originalButtonContainer) {
            const whatsappButton = document.createElement('a');
            whatsappButton.href = whatsappUrl;
            whatsappButton.target = '_blank';
            whatsappButton.textContent = 'Cotação via WhatsApp';
            whatsappButton.className = originalAddToCartButton.className;

            if (originalAddToCartButton.style) {
                for (let i = 0; i < originalAddToCartButton.style.length; i++) {
                    const prop = originalAddToCartButton.style[i];
                    whatsappButton.style[prop] = originalAddToCartButton.style[prop];
                }
            }

            originalButtonContainer.replaceChild(whatsappButton, originalAddToCartButton);
            originalButtonContainer.style.display = 'flex';
        } else {
            console.warn("ShopUfy Customization: Botão original 'Adicionar ao carrinho' ou seu contêiner não encontrado para substituição.");
        }
    }
});




document.addEventListener('DOMContentLoaded', function() {
    const targetUrls = [
        'https://azadi.store/collections/shop-all-personalize-b2b',
        'https://azadi.store/pages/b2b-personalizados-presentes-corporativos'
    ];
    // Verifica se a URL atual contém 'personalizado' ou é uma das URLs específicas
    const isRelevantPage = targetUrls.some(url => window.location.href.includes(url)) || window.location.href.includes('personalizado');

    // Se não for uma página relevante, sai do script
    if (!isRelevantPage) {
        return;
    }

    // --- Função para aplicar as modificações no DOM ---
    function applyDOMChanges() {
        // Lógica para esconder textos: "(Personalizado)" e "Pautado"
        const textsToHide = ['(Personalizado)', 'Pautado'];
        const productTitles = document.querySelectorAll('.product-block__title');

        productTitles.forEach(titleElement => {
            let currentText = titleElement.textContent;
            let updatedText = currentText; // Variável para armazenar o texto modificado

            textsToHide.forEach(text => {
                if (updatedText.includes(text)) {
                    updatedText = updatedText.replace(text, '').trim();
                }
            });

            // Só atualiza o texto se houver alguma mudança para evitar re-render desnecessário
            if (currentText !== updatedText) {
                titleElement.textContent = updatedText;
            }
        });

        // Lógica para adicionar " a unidade" aos preços
        // Seleciona ambos os tipos de elementos de preço
        const priceSelectors = ['.product-price__amount', '.current-price'];

        priceSelectors.forEach(selector => {
            const priceElements = document.querySelectorAll(selector);
            priceElements.forEach(priceElement => {
                // Verifica se o texto " a unidade" já foi adicionado
                // Procura um irmão adjacente que tenha a classe 'unit-text'
                const nextSibling = priceElement.nextElementSibling;
                const alreadyAdded = nextSibling && nextSibling.classList.contains('unit-text');

                // Se ainda não foi adicionado, cria e insere o novo elemento
                if (!alreadyAdded) {
                    const unitText = document.createElement('span');
                    unitText.textContent = ' a unid. personalizado com logotipo.'; // Adiciona um espaço antes para melhor legibilidade
                    unitText.classList.add('unit-text'); // Adiciona uma classe para identificação e possível estilização
                    
                    // Insere o novo span logo após o elemento do preço
                    priceElement.parentNode.insertBefore(unitText, priceElement.nextSibling);
                }
            });
        });
    }

    // --- Executa as modificações inicialmente quando o DOM estiver pronto ---
    applyDOMChanges();

    // --- Configura um MutationObserver para observar mudanças no DOM ---
    // Isso é crucial para lidar com conteúdo que é carregado ou re-renderizado dinamicamente
    const observer = new MutationObserver((mutationsList, observer) => {
        let relevantChangeDetected = false;
        for (const mutation of mutationsList) {
            // Se um novo nó foi adicionado à árvore do DOM
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Percorre os nós adicionados para ver se algum deles ou seus descendentes
                // contêm os elementos de preço que estamos procurando
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1) { // Verifica se é um elemento HTML
                        if (node.matches('.product-price__amount') || node.matches('.current-price') ||
                            node.querySelector('.product-price__amount') || node.querySelector('.current-price')) {
                            relevantChangeDetected = true;
                            break; // Se encontrou uma mudança relevante, pode parar de procurar nesta mutação
                        }
                    }
                }
            }
            if (relevantChangeDetected) {
                break; // Sai do loop de mutationsList se uma mudança relevante foi encontrada
            }
        }

        // Se uma mudança relevante foi detectada, reaplica as modificações
        if (relevantChangeDetected) {
            applyDOMChanges();
        }
    });

    // Inicia a observação do corpo do documento para mudanças em seus filhos e em toda a sua subárvore
    observer.observe(document.body, { childList: true, subtree: true });
});

/*
// O código é executado somente quando o documento HTML estiver totalmente carregado.
document.addEventListener("DOMContentLoaded", function() {
  // Verifique se a URL atual da página contém a palavra "personalizado".
  // A busca é feita para garantir que a alteração ocorra apenas nas páginas corretas.
  if (window.location.href.includes("personalizado")) {
    
    // Use document.querySelector para encontrar o elemento <span> específico.
    // O seletor '.with-icon__beside' é usado para encontrar a tag <span> que contém o texto "Descrição".
    const descriptionElement = document.querySelector('.with-icon__beside');

    // Verifique se o elemento foi encontrado e se o texto dele é "Descrição"
    // para evitar alterar elementos incorretos.
    if (descriptionElement && descriptionElement.innerText.trim() === "Descrição") {
      // Altera o texto do elemento para o novo valor.
      descriptionElement.innerText = "Orçamento e personalização do logo";
    }
  }
});
*/

document.addEventListener('DOMContentLoaded', function() {
  const prices = document.querySelectorAll('.product-price__amount');

  prices.forEach(function(priceElement) {
    priceElement.style.fontWeight = 'bold';
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const freeShippingCardTitle = document.querySelector('.free_shipping_card_title_cmfa2cmn200i9boaxx46x5gra');
  
  if (freeShippingCardTitle) { // Always check if the element exists
    freeShippingCardTitle.style.fontWeight = 'normal';
  }
});

// Verifica se a URL atual contém 'b2b' ou 'personalizado'.
if (window.location.href.includes('b2b') || window.location.href.includes('personalizado')) {
  // Cria um novo elemento de estilo (<style>).
  const style = document.createElement('style');
  
  // Define o conteúdo do estilo para esconder a barra de anúncios.
  style.innerHTML = '.essential_annoucement_bar_wrapper.top_page_styles { display: none !important; }';
  
  // Adiciona o elemento de estilo ao cabeçalho (<head>) do documento.
  document.head.appendChild(style);
}




// Verifica se a URL atual contém a string 'b2b'.
if (window.location.href.includes('b2b')) {
  // Define a classe CSS do elemento que queremos esconder.
  const targetClass = 'free_shipping_card';

  // Cria uma função para esconder o elemento.
  const hideElement = (element) => {
    // Define a propriedade de estilo 'display' para 'none',
    // que irá sobrescrever o estilo embutido do elemento.
    element.style.display = 'none !important';
  };

  // Cria uma instância do MutationObserver.
  const observer = new MutationObserver((mutations) => {
    // Itera sobre as mutações (mudanças no DOM).
    for (const mutation of mutations) {
      // Verifica se nós foram adicionados ao DOM.
      if (mutation.type === 'childList') {
        // Itera sobre os nós que foram adicionados.
        for (const node of mutation.addedNodes) {
          // Verifica se o nó é um elemento e se tem a classe alvo.
          if (node.nodeType === 1 && node.classList.contains(targetClass)) {
            // Esconde o elemento.
            hideElement(node);
            // Opcional: desconecta o observador após encontrar o elemento
            // para economizar recursos.
            observer.disconnect();
            // Retorna para evitar processamento desnecessário.
            return;
          }
        }
      }
    }
  });

  // Configura o observador para observar o corpo do documento e seus sub-nós
  // para mudanças na lista de filhos.
  observer.observe(document.body, { childList: true, subtree: true });
}




  // Ajusta swatches bandeiras caderno a5 copa
document.addEventListener('DOMContentLoaded', function () {

  if (!window.location.pathname.includes('caderno-journal-copa-a5')) {
    return;
  }

  const swatchLists = document.querySelectorAll('.swatch-lista');

  swatchLists.forEach(function (list) {
    list.style.display = 'flex';
    list.style.flexWrap = 'wrap';
    list.style.gap = '8px';
    list.style.alignItems = 'center';

    const links = list.querySelectorAll('a');

    links.forEach(function (link) {
      link.style.display = 'inline-flex';
      link.style.flex = '0 0 auto';
    });
  });


    // Título
  const titulo = document.querySelector('.product-detail .detail .title');

  if (titulo) {
    titulo.style.margin = '0 0 0.1em';
  }

  
});